import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  AmphoraIntegrationResponseDataSchema,
  DataResponse,
  UpdateAmphoraCommunications,
} from "schema"
import { z } from "zod"
import { amphoraIntegrationQuery } from "../../lib/amphora/amphoraIntegrationQuery"

type Response = DataResponse<z.infer<typeof AmphoraIntegrationResponseDataSchema>>

export function useUpdateAmphoraCommunicationsMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateAmphoraCommunications) => {
      const response = await axios.patch<Response>(`/integrations/amphora/communications`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: amphoraIntegrationQuery().queryKey })
    },
  })
}
